import './App.css';
import { Layout } from 'antd';
import icon from './images/harscorail.png';
import QueueAnim from 'rc-queue-anim';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import FooterContent from './components/FooterContent';
import QrLookup from './components/QrLookup';
import Lookup from './components/Lookup';
import RiskWarning from './components/RiskWarning';
const { Header, Content } = Layout;

function App() {
    return (
        <Router>
            <Layout className="layout" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
                <Header className="header">
                    <h1 className="header-title">
                        <img src={icon} alt="icon" style={{ width: '170px', height: 'auto' }} />
                    </h1>
                </Header>

                <Content className="content" style={{ flex: '1 0 auto', padding: '20px', overflow: 'auto' }}>
                    <QueueAnim delay={300} className="queue-simple">
                        <Routes>
                            <Route path="/search" element={<Lookup />} />
                            <Route path="/" element={<QrLookup />} />
                            <Route path="/risk-warning" element={<RiskWarning />} />
                            
                        </Routes>
                    </QueueAnim>
                </Content>
                <FooterContent />
            </Layout>
        </Router>
    );
}

export default App;